import React, { useState, forwardRef, useImperativeHandle } from 'react';
import UpgradeRequiredModal from '@/components/Modals/UpgradeReqiuredModal';

export interface FreePlanRequiredRef {
  openModal: () => void;
}

const FreePlanRequired = forwardRef((_, ref) => {
  const [isModal, setIsModal] = useState(false);

  const openModal = () => setIsModal(true);
  const closeModal = () => setIsModal(false);

  useImperativeHandle(ref, () => ({
    openModal,
  }));

  return (
    <>
      {isModal && (
        <UpgradeRequiredModal handleOpenModal={closeModal} isModal={isModal} />
      )}
    </>
  );
});
FreePlanRequired.displayName = 'FreePlanRequired';
export default FreePlanRequired;
